// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__(8671);
var __webpack_exports__ = __webpack_require__(5793);
